import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  currentCart: {
    items: [],
    mainItem: null,
    discount: null,
    discountDetails: [],
    productIdList: [],
    productQuantityById: {},
    productItemIdById: {},
    essentialOptions: [],
    additionalOptions: [],
    interventionOptions: [],
    installationProductInCart: false,
    standardDeliveryInCart: false,
    delivery: {
      date: "",
      hours: "",
    },
    cgv: "",
    customerServiceInfo:"",
    customerTaxId: "",
    taxHighRate: "",
    taxProfils: {},
    schedules: {},
    total: 0,
    couponCode: false,
    errorMessages: [],
    ecoTaxe: 0,
    tva: 0,
    checkoutUrl: "",
    rentingAmounts: {},
    totalWithoutDiscountReferrer: 0,
    itemsCount: 0,
    totalItemsQty: 0,
    mcp_universe: "",
    gtmDatas: {
      cartTotalExcluTax: "",
      cartTotalIncluTax: "",
      cartProductsTotal: "",
      mainProducts: []
    },
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
